import 'css-chunk:src/feature/cash-bank/CashBankBillCount.module.scss';export default {
  "formFieldWrapper": "CashBankBillCount_formFieldWrapper"
};